const CanvasSettings = {
  dimensions: {
    width: 500,
    height: 200,
  },
  padding: 8,
} as const

export default CanvasSettings
